// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--Mx8tH","items-container":"_7a3fb80146--items-container--tdy_c","item":"_7a3fb80146--item--C9DAd","title":"_7a3fb80146--title--GWHUS"};